import { TablePagination, TextField, Box } from '@mui/material';
import { Stack } from 'react-bootstrap';
import { bake } from './common';
import { useState, useEffect } from 'react';
import { ROWSPERPAGE } from './constants';

export default function PageFooter(props) {
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [goToPage, setGoToPage] = useState('');

  const totalPages = Math.ceil((props.totalRows ?? 0) / rowsPerPage);
  const currentPage = props.page + 1; // Convert 0-based to 1-based for display

  useEffect(() => {
    const rpp = parseInt(bake({ props: props, key: 'rowsPerPage' }), 10);
    bake({ props: props, key: 'rowsPerPage', value: isNaN(rpp) ? 15 : rpp });
    setRowsPerPage(isNaN(rpp) ? 15 : rpp);
  }, []);

  const handleChangePage = (event, newPage) => {
    props.setPage(newPage);
    props.updateSearchParams({ page: newPage, paging: true }, true);
  };

  const handleChangeRowsPerPage = (event) => {
    // Save selected rows per page to cookies
    bake({
      props: props,
      key: 'rowsPerPage',
      value: parseInt(event.target.value, 10),
    });
    setRowsPerPage(parseInt(event.target.value, 10));
    props.setPage(0);
    props.updateSearchParams(
      {
        rows: parseInt(event.target.value, 10),
        page: 0,
      },
      true
    );
  };

  const handleGoToPage = (event) => {
    if (event.key === 'Enter' || event.type === 'blur') {
      const pageNumber = parseInt(goToPage, 10);
      if (pageNumber >= 1 && pageNumber <= totalPages) {
        handleChangePage(null, pageNumber - 1); // Convert 1-based to 0-based
        setGoToPage('');
        // Remove focus from the textbox
        event.target.blur();
      } else {
        setGoToPage(''); // Clear invalid input
        // Remove focus from the textbox for invalid input as well
        event.target.blur();
      }
    }
  };

  const handleGoToPageChange = (event) => {
    const value = event.target.value;
    // Only allow numbers
    if (value === '' || /^\d+$/.test(value)) {
      setGoToPage(value);
    }
  };

  return (
    <>
      {props.totalRows > 0 ? (
        <Stack direction="horizontal" className="footer-container footer-text">
          {/* Selected Rows Count */}
          {props.selectedRows?.length > 0 && (
            <p className="mat-table-rows-selected">
              Rows Selected: {props.selectedRows.length}
            </p>
          )}

          <div
            className={`goto-div ${!props.myHomePage ? 'ms-auto' : 'w-100'}`}
          >
            {/* Go to Page Input */}
            <Box className="goto-page">
              <span>Go to page:</span>
              <TextField
                size="small"
                variant="outlined"
                value={goToPage}
                onChange={handleGoToPageChange}
                onKeyDown={handleGoToPage}
                onBlur={handleGoToPage}
                placeholder={currentPage.toString()}
                inputProps={{
                  min: 1,
                  max: totalPages,
                }}
              />
              <span>of {totalPages}</span>
            </Box>

            <TablePagination
              labelRowsPerPage="Rows:"
              rowsPerPageOptions={ROWSPERPAGE}
              component="div"
              count={props.totalRows ?? 0}
              rowsPerPage={rowsPerPage}
              page={props.page}
              onPageChange={(event, newValue) =>
                handleChangePage(event, newValue)
              }
              onRowsPerPageChange={(event) => handleChangeRowsPerPage(event)}
              showFirstButton={true}
              showLastButton={true}
              className={
                !props.myHomePage
                  ? 'pagination-default'
                  : 'pagination-auto-margin'
              }
            />
          </div>
        </Stack>
      ) : null}
    </>
  );
}
